import React from 'react';

import { TableRow, TableSortLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import {
  TASKS_LIST_HEADERS,
  SEARCH_TAG_TYPES,
  TASK_TYPES_2,
  GOALS_LIST_HEADERS,
  TAG_TASKS_LIST_HEADERS,
} from 'constants/ProjectConstants';

import GoalSortDropdown from './GoalSortDropdown';
import HeaderLabelIcons from './HeaderLabelIcons';
import TaskSortDropdown from './TaskSortDropdown';
import { StyledTableHead, HeaderTableCell } from './styles';

const useStyles = makeStyles((theme) => ({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 40,
    width: 1,
  },
}));

const TableHeader = ({ order, orderBy, onRequestSort, tagType, type, orderByDispatch }) => {
  const classes = useStyles();
  let headCells = tagType === SEARCH_TAG_TYPES.tag ? TAG_TASKS_LIST_HEADERS : TASKS_LIST_HEADERS;

  const isGoalType = type === TASK_TYPES_2.goal;
  if (isGoalType) {
    headCells = GOALS_LIST_HEADERS;
  } else {
    headCells = headCells.filter((header) => header.id !== 'PROGRESS');
  }
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const goalSortDropdown = (
    <GoalSortDropdown
      createSortHandler={createSortHandler}
      orderBy={orderBy}
      order={order}
      orderByDispatch={orderByDispatch}
    />
  );

  const taskSortDropdown = (
    <TaskSortDropdown
      createSortHandler={createSortHandler}
      orderBy={orderBy}
      order={order}
      orderByDispatch={orderByDispatch}
    />
  );

  return (
    <StyledTableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <StyledHeaderTableCell
            key={headCell.id}
            align={headCell.centerAlign ? 'center' : undefined}
            paddingtop="1rem"
            paddingLeft={headCell.paddingLeft ? headCell.paddingLeft : undefined}
            paddingRight={headCell.paddingRight ? headCell.paddingRight : undefined}
            paddingBottom="1rem"
            sortDirection={orderBy === (headCell.sortable && headCell.id) ? order : false}
            width={headCell.width}
          >
            {/* {isGoalType && index === 0 && goalSortDropdown} */}
            {/* {!isGoalType && index === 0 && taskSortDropdown} */}
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                hideSortIcon
              >
                <StyledTypography color="textSecondary" variant="body2" display="inline">
                  {headCell.label}
                </StyledTypography>
                <HeaderLabelIcons orderBy={orderBy} order={order} headCell={headCell} />
                {orderBy === headCell.id ? (
                  <StyledTypography
                    color="textSecondary"
                    variant="body2"
                    display="inline"
                    className={classes.visuallyHidden}
                  >
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </StyledTypography>
                ) : null}
              </TableSortLabel>
            ) : (
              <StyledTypography color="textSecondary" variant="body2" display="inline">
                {headCell.label}
              </StyledTypography>
            )}
          </StyledHeaderTableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
};

const StyledHeaderTableCell = styled(HeaderTableCell)`
  .MuiTableSortLabel-icon {
    display: none;
  }
`;

export default TableHeader;
